import React from 'react';
import { CenteredModal } from '@app/core';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { LoginContent } from './LoginContent';
import { useBoolModalState } from '@app/core';
import { SignupContent } from './SignupContent';
import { useTranslation } from 'react-i18next';
import { Account } from 'queries';

interface Props {
  isOpen: boolean;
  onRequestClose?: () => any;
  onSuccess?: (account: Account) => any;
  trackContext: 'organic' | 'session';
  billingMethod?: string | undefined;
}

export const LoginModal = ({
  isOpen,
  onRequestClose,
  onSuccess,
  trackContext,
  billingMethod,
}: Props) => {
  const { t } = useTranslation();

  const [logingIn, goToLogin, goToSignup] = useBoolModalState(false);

  return (
    <AnalyticsCategoryProvider
      category={logingIn ? Categories.LOGIN : Categories.SIGNUP}
    >
      <CenteredModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        title={
          logingIn
            ? t('login.title', { context: 'modal' })
            : t('signup.client.title', { context: 'modal' })
        }
      >
        {logingIn ? (
          <LoginContent onSignupClick={goToSignup} onSuccess={onSuccess} />
        ) : (
          <SignupContent
            onLoginClick={goToLogin}
            onSuccess={onSuccess}
            trackContext={trackContext}
            billingMethod={billingMethod}
          />
        )}
      </CenteredModal>
    </AnalyticsCategoryProvider>
  );
};
